import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";
import { formatCurrency } from "@core/utils/filter";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useProductsList() {
  // Use toast
  const toast = useToast();

  const refProductListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: "product_number", label: "編號", class: 'sticky-column', sortable: true },
    { key: "product_status_id", label: "狀態", class: 'sticky-column' },
    { key: "actions", label: "操作", class: 'sticky-column' },
    { key: "product_category_id", label: "商品分類", sortable: true },
    { key: "product_name", label: "名稱", sortable: true },
    { key: "brand", label: "品牌", sortable: true },
    { key: "quantity", label: "數量" },
    { key: "product_unit", label: "單位" },
    { key: "unit_price", label: "單價", formatter: formatCurrency },
    ...(ability.can('admin', 'products') ? [{ key: "cost", label: "成本" }] : []),
    { key: "remark", label: "備註/尺寸", sortable: true },
  ];
  const perPage = ref(10);
  const totalRow = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const productsList = ref(null);

  //filter
  const productStatusFilter = ref(null);
  const productCategoryFilter = ref(null);

  const dataMeta = computed(() => {
    const localItemsCount = refProductListTable.value
      ? refProductListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRow.value,
    };
  });

  const refetchData = () => {
    refProductListTable.value.refresh();
    // fetchProducts();
  };

  watch(
    [currentPage, perPage, searchQuery, productStatusFilter, productCategoryFilter ],
    () => {
      refetchData();
    }
  );

  const fetchProducts = (ctx, callback) => {
    // productsList.value = [{
    //   "id":"SV00051", 
    //   "status":{"id":1,"name":"發售中"},
    //   "type":"代理及安裝",
    //   "name":"代理及安裝廚房煮食爐",
    //   "brand":"N/A",
    //   "size":"N/A",
    //   "quantity":"1",
    //   "unit":"次",
    //   "price":"1600",
    //   "cost":"800",
    //   "remark":"EEEEEEEEEEE",
    // }]
    
    store
      .dispatch("product/fetchProducts", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        product_status_id: productStatusFilter.value, 
        product_category_id: productCategoryFilter.value
      })
      .then((response) => {
        const { products, total } = response.data;
        callback(products);
        totalRow.value = total;
        productsList.value = products
      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "獲取貸款清單時出錯",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  const productStatuses = ref([]);
  const productCategories = ref([]);
 

  const refetchOption = () => {
    store
      .dispatch("app/fetchOptionList", {
        product_statuses: true,
        product_categories: true,
      })
      .then((response) => {
        productStatuses.value = response.data.product_statuses;
        productCategories.value = response.data.product_categories;
      });
  };

  onMounted(() => {
    refetchOption();
  });

  return {
    fetchProducts,
    tableColumns,
    perPage,
    currentPage,
    totalRow,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    productsList,
    refProductListTable,
    ability,
    refetchData,
    productStatuses,
    productCategories,
    productStatusFilter,
    productCategoryFilter
  };
}
